/**
 * A closure which accepts an immutable.List of Alt.js actions and returns an
 * interceptResponse function that can intercept and return a {args, response}
 * object for those actions instead of just response
 * @param  {immutable.List} actions A list of Alt.js actions
 * @return {function}         An interceptResponse function
 */
const interceptResponseAndArgs = actions => {
  return (response, action, args) => {
    if (actions.includes(action)) {
      return {args, response};
    } else {
      return response;
    }
  };
};

export default interceptResponseAndArgs;
